import { APITransport } from '@client/transports/api';

export const SettingsService = {
  /**
   * @typedef {Object} Settings
   * @property {boolean} [attsattop]
   * @property {boolean} [keepattachments]
   * @property {boolean} [autotrackdocs]
   * @property {boolean} [autotrackemails]
   * @property {boolean} [autotracklinks]
   * @property {boolean} [desktopnotifyadclick]
   * @property {boolean} [desktopnotifyattachmentdownload]
   * @property {boolean} [desktopnotifyattachmentview]
   * @property {boolean} [desktopnotifybeaconview]
   * @property {boolean} [desktopnotifylinkclick]
   * @property {boolean} [desktopnotifymsg]
   * @property {boolean} [desktopnotifymyvideoactivity]
   * @property {boolean} [desktopnotifywebsitevisit]
   * @property {boolean} [enableatticon]
   * @property {boolean} [enablesales]
   * @property {boolean} [enabletiming]
   * @property {boolean} [notifyadclick]
   * @property {boolean} [notifyattachmentdownload]
   * @property {boolean} [notifyattachmentview]
   * @property {boolean} [notifybeaconview]
   * @property {boolean} [notifylinkclick]
   * @property {boolean} [notifymyvideoactivity]
   * @property {boolean} [notifywebsitevisit]
   * @property {boolean} [pushnotifyadclick]
   * @property {boolean} [pushnotifyattachmentdownload]
   * @property {boolean} [pushnotifyattachmentview]
   * @property {boolean} [pushnotifybeaconview]
   * @property {boolean} [pushnotifylinkclick]
   * @property {boolean} [pushnotifymyvideoactivity]
   * @property {boolean} [pushnotifywebsitevisit]
   * @property {boolean} [usequickhash]
   */

  /**
   * Save user settings
   * @param {Settings} settings
   * @returns {Promise<boolean>}
   */
  async saveUserSettings(settings) {
    return APITransport.post({
      path: '/rest/user/usersettings/save',
      body: settings
    });
  }
};
